<div class="row">
    <div [ngClass]="infoTooltip ? 'col-lg-6 col-md-12' : 'col-lg-10 col-md-12'">
        <div class="page-title-small mt-4">{{parentTitle}}</div>
        <div class="page-title">{{childTitle}}</div>
    </div>
    <div class="col-lg-6 col-md-12" *ngIf="infoTooltip">
        <div class="blue-box icon mt-4 info__tooltip">
            <svg-icon name="info-icon" svgClass="mr-2"></svg-icon>
            {{infoTooltip}}
          </div>
    </div>
</div>

